import { ShiftPlanFormValue } from '@wilson/interfaces';

export interface ShiftPlanSplitMeta {
  sourcePlanId: string;
  patternRolloutDate: string;
}

export class SetShiftPlanDuplicateFormAction {
  static readonly type = '[ShiftPlanningDetail] Duplicate Shift Plan';
  constructor(
    public shiftPlanForm: ShiftPlanFormValue,
    public split?: ShiftPlanSplitMeta,
  ) {}
}
export class ResetShiftPlanDuplicateForm {
  static readonly type = '[ShiftPlanningDetail] Reset Duplicate Shift Plan';
}
